import Thankyou from './ThankyouContainer';

export default Thankyou;
